import { useMemo } from 'react'

import { IUploadLogAggregationFilterInput } from '~/client/graph'
import { useGetUploadLogFacetsQuery } from '~/client/graph/operations/generated/FileUploader.generated'
import { UNASSIGNED_FILTER_OPTION } from '~/client/src/shared/components/Deliveries/DeliveriesView.store'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'
import { getLocationValues } from '~/client/src/shared/utils/logisticsHelper'

export default function useUploadLogFacets(
  projectId: string,
  filters: IUploadLogAggregationFilterInput = {},
  {
    locationAttributesStore,
  }: { locationAttributesStore: LocationAttributesStore },
) {
  const { data, loading: facetsLoading } = useGetUploadLogFacetsQuery({
    variables: {
      filter: {
        projectId,
        ...filters,
      },
    },
    skip: !projectId,
    fetchPolicy: 'network-only',
  })

  const facetsData = useMemo(() => {
    return {
      companyFilters: data?.uploadLogsFacets?.companyFilters || [],
      locationFilters:
        data?.uploadLogsFacets?.locationFilters?.map(facet => ({
          ...facet,
          key:
            getLocationValues([facet.key], locationAttributesStore)[0] ||
            UNASSIGNED_FILTER_OPTION,
        })) || [],
      fileTypeFilters: data?.uploadLogsFacets?.fileTypeFilters || [],
      fileCategoryFilters: data?.uploadLogsFacets?.fileCategoryFilters || [],
      userFilters: data?.uploadLogsFacets?.userFilters || [],
      workflowCategoryFilters:
        data?.uploadLogsFacets?.workflowCategoryFilters || [],
      workflowTypeFilters: data?.uploadLogsFacets?.workflowTypeFilters || [],
    }
  }, [data, locationAttributesStore.allAttributes])

  return { facetsData, facetsLoading }
}
